export const STEP_EXIT = 'EXIT';
export const STEP_START = 'START';
export const STEP_SECTION_INTRO = 'SECTION_INTRO';
export const STEP_SECTION_QUESTIONS = 'QUESTIONS';
export const STEP_FINISH = 'FINISH';
